import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import PopoverPopupState from './PopoverPopupState';
import ClientProvider from './client';
export default createDemo(import.meta.url, PopoverPopupState, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/popover/demos/popup-state/PopoverPopupState.tsx",
    "fileName": "PopoverPopupState.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Typography from '@mui/material/Typography';\nimport Button from '@mui/material/Button';\nimport Popover from '@mui/material/Popover';\nimport PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';\n\nexport default function PopoverPopupState() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 2,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <PopupState variant=\"popover\" popupId=\"demo-popup-popover\">\n      {(popupState) => (\n        <div>\n          <Button variant=\"contained\" {...bindTrigger(popupState)}>\n            Open Popover\n          </Button>\n          <Popover\n            {...bindPopover(popupState)}\n            anchorOrigin={{\n              vertical: 'bottom',\n              horizontal: 'center',\n            }}\n            transformOrigin={{\n              vertical: 'top',\n              horizontal: 'center',\n            }}\n          >\n            <Typography sx={{ p: 2 }}>The content of the Popover.</Typography>\n          </Popover>\n        </div>\n      )}\n    </PopupState>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 31,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Typography from '@mui/material/Typography';\nimport Button from '@mui/material/Button';\nimport Popover from '@mui/material/Popover';\nimport PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';\n\nexport default function PopoverPopupState() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 2
        },
        "    <PopupState variant=\"popover\" popupId=\"demo-popup-popover\">\n      {(popupState) => (\n        <div>\n          <Button variant=\"contained\" {...bindTrigger(popupState)}>\n            Open Popover\n          </Button>\n          <Popover\n            {...bindPopover(popupState)}\n            anchorOrigin={{\n              vertical: 'bottom',\n              horizontal: 'center',\n            }}\n            transformOrigin={{\n              vertical: 'top',\n              horizontal: 'center',\n            }}\n          >\n            <Typography sx={{ p: 2 }}>The content of the Popover.</Typography>\n          </Popover>\n        </div>\n      )}\n    </PopupState>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "totalLines": 31,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Typography",
      "@mui/material/Button",
      "@mui/material/Popover",
      "material-ui-popup-state"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
